// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4erXU","fullView":"styles_fullView__23ne4"};